import { z } from "zod";
// =============================================================================
// SSE EVENT TYPES (backend emits these on GET /conversations/events)
// =============================================================================
export const SSE_CONVERSATION_EVENT_TYPES = {
    CONVERSATION_CREATED: "conversation.created",
    CONVERSATION_CLOSED: "conversation.closed",
    CONVERSATION_INVALIDATED: "conversation.invalidated",
    MESSAGE_CREATED: "message.created",
    MESSAGE_UPDATED: "message.updated",
    MESSAGE_DELETED: "message.deleted",
    NOTIFICATIONS_CHANGED: "notifications.changed",
};
export const ConversationSSEEventSchema = z.object({
    type: z.string(),
    conversationId: z.coerce.string().optional(),
});
export const MessageCreatedEventSchema = ConversationSSEEventSchema.extend({
    type: z.literal(SSE_CONVERSATION_EVENT_TYPES.MESSAGE_CREATED),
    conversationId: z.coerce.string(),
});
export const ConversationClosedEventSchema = ConversationSSEEventSchema.extend({
    type: z.literal(SSE_CONVERSATION_EVENT_TYPES.CONVERSATION_CLOSED),
    conversationId: z.coerce.string(),
});
export const ConversationInvalidatedEventSchema = ConversationSSEEventSchema.extend({
    type: z.literal(SSE_CONVERSATION_EVENT_TYPES.CONVERSATION_INVALIDATED),
    conversationId: z.coerce.string(),
});
